import { createCRUDHook } from './createCRUDHook';
import { DraftPartDrawingLinkVersionDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DraftPartDrawingLinkVersionDto>({
    entityName: 'DraftPartDrawingLinkVersion',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  });

export const DraftPartDrawingLinkVersionContext = Context;
export const useDraftPartDrawingLinkVersionManager = useManager;
export const useDraftPartDrawingLinkVersion = useConsumer;
